import { render, staticRenderFns } from "./RegistrationCompany.vue?vue&type=template&id=20f561b2&"
import script from "./RegistrationCompany.vue?vue&type=script&lang=js&"
export * from "./RegistrationCompany.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationCompany.vue?vue&type=style&index=0&id=20f561b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports